import { render, staticRenderFns } from "./DetailOrderRow.vue?vue&type=template&id=c82d08b2&scoped=true&"
import script from "./DetailOrderRow.vue?vue&type=script&lang=js&"
export * from "./DetailOrderRow.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderRow.vue?vue&type=style&index=0&id=c82d08b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82d08b2",
  null
  
)

export default component.exports